import { render, staticRenderFns } from "./RollingAnnounce.vue?vue&type=template&id=7deb0d13&scoped=true"
import script from "./RollingAnnounce.vue?vue&type=script&lang=js"
export * from "./RollingAnnounce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb0d13",
  null
  
)

export default component.exports